import { ConversationsSdkImpl } from "~/modules/conversations/ConversationsSdkImpl";
import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { getReservationsByTask, sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { Conversation, ConversationImpl } from "~/modules/Conversation";





















export class GetConversationByTask implements Action<Promise<Conversation>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}): Promise<Conversation> {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        const conversations = context.retrieveInstanceOf(ContextInstance.ConversationsSdkImpl, ConversationsSdkImpl);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        await taskRouter.init();
        const worker = taskRouter.worker;

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find(
            (res) => res.status === "pending" || res.status === "accepted" || res.status === "wrapping"
        );

        if (!reservation) {
            const errorMsg = `GetConversationByTask: No pending, accepted or wrapping reservation found for task ${
                this.#taskSid
            }`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.GetConversationByTaskCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        const conversationSid = reservation.task.attributes.conversationSid;

        if (!conversationSid) {
            const errorMsg = `GetConversationByTask: No conversationSid found for task ${this.#taskSid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.GetConversationByTaskCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        try {
            await conversations.init();
        } catch (error) {
            const errorMsg = `GetConversationByTask: Failed to initialize Conversations SDK`;
            logger.error(errorMsg, error);
            sendTrackingEvent(EVENTS.GetConversationByTaskCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        if (reservation.status === "accepted") {
            try {
                
                const conversation = await conversations.getConversationBySid(conversationSid);
                sendTrackingEvent(EVENTS.GetConversationByTaskCompleted, analytics, worker, {
                    taskSid: this.#taskSid,
                    conversationSid
                });
                return new ConversationImpl(context, conversation);
            } catch (error) {
                const errorMsg = `GetConversationByTask: Failed to get conversation by sid ${conversationSid}`;
                logger.error(errorMsg, error);
                sendTrackingEvent(EVENTS.GetConversationByTaskCompleted, analytics, worker, {
                    error: errorMsg,
                    taskSid: this.#taskSid,
                    conversationSid
                });
                throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
            }
        } else {
            try {
                
                const conversation = await conversations.peekConversationBySid(conversationSid);
                sendTrackingEvent(EVENTS.GetConversationByTaskCompleted, analytics, worker, {
                    taskSid: this.#taskSid,
                    conversationSid
                });
                return new ConversationImpl(context, conversation);
            } catch (error) {
                const errorMsg = `GetConversationByTask: Failed to peek conversation by sid ${conversationSid}`;
                logger.error(errorMsg, error);
                sendTrackingEvent(EVENTS.GetConversationByTaskCompleted, analytics, worker, {
                    error: errorMsg,
                    taskSid: this.#taskSid,
                    conversationSid
                });
                throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
            }
        }
    }
}
